import { render, staticRenderFns } from "./appRedirect.vue?vue&type=template&id=01781fb1&scoped=true&"
import script from "./appRedirect.vue?vue&type=script&lang=js&"
export * from "./appRedirect.vue?vue&type=script&lang=js&"
import style0 from "./appRedirect.vue?vue&type=style&index=0&id=01781fb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01781fb1",
  null
  
)

export default component.exports